import { app } from '../../../../../../../bootstrap/core';

import './receivingBankToDo/receivingBankToDo';

import { createRequestAdvancedSettingsComponent } from './advancedSettings.component';

app.component(
  createRequestAdvancedSettingsComponent.name,
  createRequestAdvancedSettingsComponent,
);
